/* global axios */

import ApiClient from '../ApiClient';

class PrestaShopAPI extends ApiClient {
  constructor() {
    super('integrations/prestashop', { accountScoped: true });
  }

  getStores() {
    return axios.get(`${this.url}/stores`);
  }

  searchOrders(hookId, query, searchType) {
    return axios.get(`${this.url}/search_orders`, {
      params: { hook_id: hookId, query, search_type: searchType },
    });
  }

  getOrderDetails(hookId, orderId) {
    return axios.get(`${this.url}/order_details`, {
      params: { hook_id: hookId, order_id: orderId },
    });
  }

  getContactOrders(contactId) {
    return axios.get(`${this.url}/contact_orders`, {
      params: { contact_id: contactId },
    });
  }

  testConnection(url, apiKey) {
    return axios.post(`${this.url}/test_connection`, {
      url,
      api_key: apiKey,
    });
  }

  syncContact(hookId, orderId, contactId) {
    return axios.post(`${this.url}/sync_contact`, {
      hook_id: hookId,
      order_id: orderId,
      contact_id: contactId,
    });
  }

  updateHook(hookId, settings) {
    return axios.patch(`${this.baseUrl()}/integrations/hooks/${hookId}`, {
      hook: { settings },
    });
  }
}

export default new PrestaShopAPI();
